export const DEBUG_PATH = "debug";
